import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full max-w-xl p-8 flex flex-col space-y-2" }
const _hoisted_2 = { class: "text-lg font-semibold text-gray-900" }
const _hoisted_3 = { class: "text-base leading-normal text-gray-600 pb-8" }
const _hoisted_4 = { class: "w-full justify-start flex flex-row items-center space-x-4" }
const _hoisted_5 = {
  key: 0,
  class: "flex justify-between p-4 mt-3 text-md font-semibold leading-none text-white bg-danger-400 border-danger-600 rounded-lg"
}
const _hoisted_6 = { class: "flex w-3/4" }

import { PropType, ref } from 'vue';
import { BaseButton } from '@/lib/components/Button';
import { BaseTextInput } from '@/lib/components/Input';
import { Patient } from '@/models';
import axios, { CancelTokenSource } from 'axios';
import { CopdPatientService } from '@/services/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvitePatientModal',
  props: {
  patient: {
    type: Object as PropType<Patient>,
    required: true
  }
},
  emits: ["update-invitation-banner"],
  setup(__props, { emit }: { emit: ({
  (e: 'update-invitation-banner'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;




const inviteErrors = ref('');
const request = ref<CancelTokenSource | null>(null);
const copdPatientService = new CopdPatientService();
const invitePatient = async () => {
  try {
    request.value = axios.CancelToken.source();
    await copdPatientService.invitePatient(props.patient.id, {
      cancelToken: request.value.token
    });
    inviteErrors.value = '';
    request.value = null;
    emit('update-invitation-banner');
  } catch (e) {
    inviteErrors.value = e.response.data.message;

    if (!axios.isCancel(e)) {
      inviteErrors.value = e.response.data.message;
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('custom.uhb.copd.patient-invitation-title')), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('custom.uhb.copd.patient-invitation-desc')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(BaseTextInput), {
        label: _ctx.$t('custom.uhb.copd.patient-invitation-email-label'),
        class: "flex-1",
        placeholder: _ctx.$t('platform.profile.email'),
        "model-value": __props.patient.email,
        disabled: true
      }, null, 8, ["label", "placeholder", "model-value"]),
      _createVNode(_unref(BaseButton), {
        "data-dusk": "send-invite",
        class: "mt-8",
        size: "large",
        color: "primary",
        onClick: _withModifiers(invitePatient, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('platform.user.send-invite')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (inviteErrors.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(inviteErrors.value), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})